import { Button, Col, DatePicker, Form, Input, Modal, Popconfirm, Row, Select, Table } from 'antd';
import { useEffect, useState } from 'react';
import { API } from '../../api';
import { notifyError } from '../../store/utils';
import dayjs from 'dayjs';
const reasonList = [
  { value: 'TAX', label: 'Илгээмж дээр татвар төлөгдөөгүй' },
  { value: 'PRICE', label: 'Илгээмжийн үнэ тодорхойгүй' },
  { value: 'FORBIDDEN', label: 'Илгээмж зохисгүй бараа агуулсан' },
  { value: 'RECIPIENT_INFO', label: 'Хүлээн авагчийн мэдээлэл дутуу' },
];
interface CustomsProcessModalProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (list: any, airBill: string) => void;
  airBill: any;
}
export const CustomsProcessModal = ({
  visible,
  onCancel,
  onOk,
  airBill,
}: CustomsProcessModalProps) => {
  const [code, changeCode] = useState('');
  const [reason, changeReason] = useState('TAX');
  const [list, changeList] = useState<any[]>([]);
  const [checkLoading, changeCheckLoading] = useState(false);
  const [date, setDate] = useState<any>(null);
  useEffect(() => {
    if (visible) {
      changeCode('');
      changeReason('TAX');
      changeCheckLoading(false);
      changeList([]);
      setDate(dayjs());
    }
  }, [visible, airBill]);
  const onKeydown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      const result = code.replace(/\s+/g, '').toUpperCase();
      if (result.length > 12) {
        checkTrackingNumber(result, airBill);
      } else {
        changeCode(result);
      }
    }
  };
  const checkTrackingNumber = async (trackingNumber: string, airBill: string) => {
    try {
      changeCheckLoading(true);
      const response = await API.get({})(
        `/customs/check?airBill=${airBill}&trackingNumber=${trackingNumber}`
      );
      if (response.result.exists) {
        changeList((prev) => [...prev, { index: prev.length + 1, code: trackingNumber, reason }]);
        changeCode('');
        changeReason('TAX');
      } else {
        notifyError('Илгээмжийн код буруу байна');
      }
    } catch (e) {
      notifyError('Илгээмжийн код буруу байна');
    }
    changeCheckLoading(false);
  };
  const submitProcess = async (list: any[], airBill: string) => {
    try {
      const response = await API.post({ apiVersion: 'api' })('/customs/process/internal', {
        airBill,
        processTime: dayjs(date),
        detainList: list.map((item) => ({ trackingNumber: item.code, reason: item.reason })),
      });
      onOk(list, airBill);
    } catch (e) {
      notifyError('Үйлдэл амжилтгүй боллоо');
    }
  };
  const columns = [
    {
      title: '#',
      render: (val: any, row: any) => <span>{row.index}</span>,
    },
    {
      title: 'tracking number',
      width: '100',
      render: (val: any, row: any) => <span>{row.code}</span>,
    },
    {
      title: 'Шалтгаан',
      width: '100',
      render: (val: any, row: any) => {
        const reason = reasonList.find((r) => r.value === row.reason);
        return <span>{reason?.label || row.reason}</span>;
      },
    },
  ];
  return (
    <Modal
      loading={checkLoading}
      title={'Хураагдсан илгээмж бүртгэх -' + airBill}
      open={visible}
      footer={[
        <Button onClick={onCancel}>Болих</Button>,
        <Popconfirm
          title={`Бүртгэх үйлдэл буцаах боломжгүйг анхаарна уу!`}
          description={`Хураагдсан илгээмжийн тоо: ${list.length} `}
          onConfirm={() => submitProcess(list, airBill)}
        >
          <Button type="primary">Бүртгэх</Button>
        </Popconfirm>,
      ]}
      onCancel={onCancel}
    >
      <Form layout="vertical">
        <Row gutter={16}>
          <Col span={24}>
            <DatePicker showTime onChange={(e) => setDate(e)} value={date} />
          </Col>
          <Col span={12}>
            <Form.Item label="Хураагдсан илгээмжийн код">
              <Input
                value={code}
                onChange={(e) => changeCode(e.target.value)}
                onKeyDown={onKeydown}
                autoFocus={true}
                placeholder="___-____-___"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Шалтгаан">
              <Select value={reason} onChange={(val) => changeReason(val)}>
                <Select.Option value="TAX">Илгээмж дээр татвар төлөгдөөгүй</Select.Option>
                <Select.Option value="PRICE">Илгээмжийн үнэ тодорхойгүй</Select.Option>
                <Select.Option value="FORBIDDEN">Илгээмж зохисгүй бараа агуулсан</Select.Option>
                <Select.Option value="RECIPIENT_INFO">Хүлээн авагчийн мэдээлэл дутуу</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        rowKey={(record) => 'scan' + record.index}
        columns={columns}
        showHeader={false}
        size={'small'}
        pagination={false}
        dataSource={list}
      />
    </Modal>
  );
};
